<template>
    <div class="page">
        <my-scroll scroll-state  ref="myScroll" :page="page" :on-pull="onPull" class="page-container">
            <div slot="scrollList">
                <div class="public-head">
                    <Head></Head>
                    <div class="big-baikuang">
                        <p>{{$t('todayLogs.TodayLogs')}}</p>
                        <span>{{total}}</span>
                    </div>
                </div>
                <div class="list-box">
                    <div class="Profile-today-list" v-for="item in info" :key="item.logId">
                        <p :class="item.ctype" class ="Profile-today-list-p1 lan">
                            {{$t(item.ctype)}}
                        </p>
                        <p class ="Profile-today-list-p2">{{dateFormat(item.creationTime)}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.displayMerchantName ? item.displayMerchantName : null}}</p>
                        <p class ="Profile-today-list-p3">{{item.expressNumber}}</p>
                        <img :src = "item.clogo">
                    </div>
                </div>
            </div>
        </my-scroll>
        <!-- <div class="Profile-back" @click="back()">
            {{$t('common.Back')}}
        </div>
        <bottom></bottom> -->
        <div class="back_bt">
          <button class="back_bt_w" @click="$router.back()">{{$t('common.Back')}}</button>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from '../Bottom.vue'
import MyScroll from '../MyScroll'
import ColectLogo from '../../assets/image/todayLog/todaylogs-collect.png'
import ReturnExpiredLogo from '../../assets/image/todayLog/todaylogs-expired.png'
import ReturnsLogo from '../../assets/image/todayLog/todaylogs-return.png'
import StoreLogo from '../../assets/image/todayLog/todaylogs-store.png'
import Head from './Head.vue'
export default {
  name: 'TodayLogs',
  components: {bottom, MyScroll, Head},
  data () {
    return {
      info: [],
      total: 0,
      param: null,
      page: {
        total: 0
      },
      locationName: localStorage.getItem('locationName')
    }
  },
  methods: {
    getData (param) {
      const vue = this
      this.axios({
        method: 'get',
        url: this.api.queryLogs,
        params: param
      }).then(function (response) {
        let tmp = response.data.content
        for (let i = 0; i < tmp.length; i++) {
          switch (tmp[i].displayOperatorType) {
            case 'Collect':
              tmp[i].ctype = 'Collect'
              tmp[i].clogo = ColectLogo
              break
            case 'Store/Return':
              tmp[i].ctype = 'Store-Return'
              tmp[i].clogo = StoreLogo
              break
            case 'Store':
              tmp[i].ctype = 'Store'
              tmp[i].clogo = StoreLogo
              break
            case 'Return Expired':
              tmp[i].ctype = 'ReturnExpired'
              tmp[i].clogo = ReturnExpiredLogo
              break
            case 'Returns':
              tmp[i].ctype = 'Returns'
              tmp[i].clogo = ReturnsLogo
              break
            default:
              tmp[i].ctype = 'Store'
              tmp[i].clogo = StoreLogo
              break
          }
          vue.info.push(tmp[i])
        }
        vue.total = response.data.totalElements
        vue.page.total = response.data.totalPages
      }).catch(function (error) {
        console.log(error)
      })
    },
    back () {
      this.$router.back()
    },
    dateFormat (time) {
      let monthArr = this.$t('common.monthArr')
      time = new Date(time)
      let m = monthArr[time.getMonth()] // + this.$t('common.space')
      let d = time.getDate() + this.$t('common.dayFormat') + this.$t('common.space')
      let h = time.getHours()
      if (h.toString().length === 1) {
        h = '0' + h
      }
      let mm = time.getMinutes()
      if (mm.toString().length === 1) {
        mm = '0' + mm
      }
      let dateStr = d + m + ', ' + h + ':' + mm
      return dateStr
    },
    onPull () { // 加载回调
      const vue = this
      if (this.param.page < this.page.total) {
        setTimeout(() => {
          this.param.page++
          // 加载完成
          this.$refs.myScroll.setState(5)
          vue.getData(vue.param)
        }, 500)
      } else {
        // 没有数据了
        this.$refs.myScroll.setState(7)
      }
    }
  },
  created () {
    // 初始化注入&校验时请求页面数据
    let time = new Date()
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let day = time.getDate()
    if (month.toString().length === 1) {
      month = '0' + month
    }
    if (day.toString().length === 1) {
      day = '0' + day
    }
    let one_day = year + month + day
    let param = {day: one_day, page: 0, size: 10, sort: 'lastUpdatedTime,desc'}
    // let param = {page: 0, size: 10, sort: 'lastUpdatedTime,desc'}
    this.param = param
    this.getData(param)
  }
}
</script>

<style src="../../assets/css/bootstrap.css" scoped>
</style>
<style scoped>
    .expired_more{
        /*padding-top: 2rem;*/
        /*top:1.7rem;*/
    }
    .Profile-back{
        text-align: center;
        position: fixed;
        width: 82.4%;
        height: 0.58rem;
        bottom: 1.5rem;
        /* margin-left: 8.8%; */
        /* margin-top: 0.33rem !important; */
        box-shadow:0px 10px 20px rgba(0,0,0,0.16);
        border-radius:84px;
        background-color: #FFFFFF;
        /* color: #052460; */
        color: var(--primary-inverted-button-text-color);
        font-size:0.2rem;
        /*font-weight:bold;*/
        font-family: Poppins-Bold;
        line-height:0.58rem;
        margin-bottom: 0.19rem !important;
        max-width: 400px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
    .Collect{
      /* color:rgba(0,172,78,1); */
      color: var(--collected-label-color);
    }
    .Store-Return{
      /* color:rgba(31,141,197,1); */
      color: var(--stored-label-color);
    }
    .Store{
      /* color:rgba(31,141,197,1); */
      color: var(--stored-label-color);
    }
    .ReturnExpired{
      /* color:rgba(90,90,90,1); */
      color: var(--return-label-color);
    }
    .Returns{
      /* color:rgba(178,70,154,1); */
      color: var(--return-label-color);
    }
    .bottom{
        /*position: relative;*/
        /*bottom: -3.38rem;*/
    }
    .list-box{
        margin-top: 0.2rem;
        min-height: calc(64vh);
        padding-bottom: 1.2rem;
    }
    .Profile-today-list{
        float: unset;
    }
    .my-scroll{
        /* margin-bottom: 1rem; */
        /* padding-bottom: 1rem; */
    }
    .Profile-back{
        bottom: 0.3rem;
    }
</style>
<style lang="less" scoped>
  .page {
    .page-container{
      max-height: 100vh;
      max-height: 100svh;
      max-height: 100dvh;
      overflow-y: auto;
    }
    .back_bt {
      position: fixed;
      width: 82%;
      // left: 9%;
      bottom: 0.4rem;
      z-index: 999;
      max-width: 400px;
      left: 50%;
      transform: translateX(-50%);
      .back_bt_w {
        width: 100%;
        height: 0.58rem;
        // background: rgba(255, 255, 255, 1);
        background: var(--primary-inverted-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.42rem;
        border: none;
        // color: rgba(5, 36, 96, 1);
        color: var(--primary-inverted-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
      .back_bt_b {
        margin-top: 0.1rem;
        width: 100%;
        height: 0.58rem;
        // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
        // background: linear-gradient(to right, #191E96 , #00BEF5 );
        background: linear-gradient(to right, #01BAFF , #01BAFF );
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        border: none;
        color: #ffffff;
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
    }
    .bottom {
      position: fixed;
      bottom: 0.06rem;
      max-width: 400px;
      max-width: 400px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
  }
  .loading-container{
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--primary-label-color);
    padding: 10px;
    cursor: pointer;
    gap: 10px;
    font-size: 18px;
  }
  .loading-spinner {
    -webkit-animation:spin 1.5s linear infinite;
    -moz-animation:spin 1.5s linear infinite;
    animation:spin 1.5s linear infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/Acount/TodayLogs.vue